import { Match } from './match';
import { Eventi } from './eventi';
import { EventiDirette } from './eventi-dirette';
import { StatiDirette } from './stati-dirette';
import { Marcature } from './marcature';

export class Dirette {
    UserCanModify: boolean = null;
    risultato: string = null;
    id: number = null;
    id_wp_match: number = null;
    portale: string = null;
    stato: number = null;
    team1_score: number = null;
    team2_score: number = null;
    utente: string = null;
    match: Match = null;
    arbitro: string = null;
    collaboratori: string = null;
    inizioStatoCorrente: Date = null;
    tipiEvento: Eventi[] = null;
    eventiDiretta: EventiDirette[] = null;
    statiDirette: StatiDirette[] = null;
    categoriaStatoCorrente: number = null;
    marcatori: string = null;
    ammoniti: string = null;
    espulsi: string = null;
    descrizioneStato: string = null;
    marcatureTeam1: Marcature[] = null;
    marcatureTeam2: Marcature[] = null;
    marcatureMatch: Marcature[] = null;
    competizione: string = null;
    giornata: string = null;
    inizio_stato: Date = null;

    descrizioneMatch: string = null;
    dataMatch: string = null;
    utenteCustom: string = null;
    linkDettaglioCustom: string = null;
    linkPortaleCustom: string = null;
    annullaAssegnazioneCustom: string = null;
    statoCorrente: StatiDirette = null;

    visiteTotali: number;
    ipUnivoci: number;
    data: Date;

    constructor(){
        this.match = new Match();
        this.tipiEvento = new Array<Eventi>();
        this.eventiDiretta = new Array<EventiDirette>();
        this.statiDirette = new Array<StatiDirette>();
        this.statoCorrente = new StatiDirette();
        this.marcatureTeam1 = new Array<Marcature>();
        this.marcatureTeam2 = new Array<Marcature>();
        this.marcatureMatch = new Array<Marcature>();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/dirette.ts